import { GraphQLClient } from "graphql-request";
import { GraphQLClientResponse } from "graphql-request/build/esm/types";

import { IS_PRODUCTION } from "constants/isProductionEnv";
import { parseClientError } from "utils/error.util";

import { getSdk } from "../graphql/type";

/**
 * graphql-requestを使ったgetSdkのラッパー
 */

export const useSdk = () => {
  return (idToken: string) => {
    const client = new GraphQLClient(process.env.NEXT_PUBLIC_API_URL, {
      requestMiddleware: async (request) => {
        if (!IS_PRODUCTION) {
          // console.log("リクエストデータ: ", request);
        }
        return request;
      },
      responseMiddleware: async (response: GraphQLClientResponse<unknown> | Error) => {
        if (!IS_PRODUCTION) {
          if (response instanceof Error) {
            console.error("エラー: ", parseClientError(response));
          } else {
            // console.log("レスポンスデータ: ", response);
          }
        }
      },
    });
    client.setHeader("Authorization", `Bearer ${idToken}`);

    return getSdk(client);
  };
};
